import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';

const TermsPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-zinc-300 font-sans">
      <nav className="fixed w-full z-50 bg-[#0a0a0a]/90 backdrop-blur-lg border-b border-zinc-800">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <button 
              onClick={() => navigate('/')}
              className="flex items-center space-x-3"
            >
              <h1 className="text-2xl font-bold text-white font-poppins">
                BLACKBOX<span className="text-purple-500">mi</span>
              </h1>
            </button>
            <button
              onClick={() => navigate('/')}
              className="text-zinc-400 hover:text-white transition-colors font-medium"
            >
              Back to Home
            </button>
          </div>
        </div>
      </nav>

      <main className="pt-32 pb-16">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center mb-12">
            <div className="inline-flex justify-center items-center p-3 bg-purple-500/10 rounded-full mb-6">
                <FileText className="w-8 h-8 text-purple-500" />
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4 font-poppins">Terms of Service</h1>
            <p className="text-lg text-zinc-500">Last Updated: November 20, 2025</p>
          </div>

          <div className="prose prose-invert prose-lg max-w-none space-y-8 text-zinc-300">
            <p>Welcome to BLACKBOXmi. These Terms of Service (&ldquo;Terms&rdquo;) govern your use of our marketing intelligence platform provided by <strong>BLACKLIGHT Films/BLACKBOXis</strong>.</p>
            
            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">1. Service Description</h2>
              <p>BLACKBOXmi provides AI-powered tools for film marketing, including:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Audience Genius:</strong> Demographic and psychographic analysis.</li>
                <li><strong>Revenue Forecaster:</strong> Box office and streaming revenue projections.</li>
                <li><strong>Content Generation:</strong> Automated creation of press kits, ad copy, and visual assets.</li>
                <li><strong>Campaign Management:</strong> Tools for planning and tracking marketing budgets.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">2. AI & Financial Disclaimer</h2>
              <div className="p-4 bg-red-900/10 border border-red-500/30 rounded-lg mb-4">
                <p className="text-red-300 font-medium">CRITICAL NOTICE REGARDING FORECASTS:</p>
                <p className="text-sm mt-2 text-red-200/80">
                    The revenue forecasts, budget recommendations, and success probabilities generated by BLACKBOXmi are estimates based on historical data and AI analysis. They do <strong>NOT</strong> constitute financial advice, guarantees of profit, or assurances of distribution. Film investment carries inherent risks. You are solely responsible for your financial decisions.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">3. Subscription & Credits</h2>
              <div className="pl-4 border-l-2 border-zinc-800">
                <ul className="list-disc pl-6 space-y-2">
                  <li><strong>Credit System:</strong> Services are accessed via credits. Unused credits do not roll over month-to-month unless explicitly stated in your plan.</li>
                  <li><strong>Free Trial:</strong> The 7-day trial includes a limited credit allocation (25 credits). Upon trial expiration, the full monthly subscription fee is charged automatically.</li>
                  <li><strong>Cancellation:</strong> You may cancel anytime. Cancellation stops the auto-renewal; you retain access until the end of your current billing cycle.</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">4. Intellectual Property</h2>
              <p>You retain ownership of your original film data (scripts, loglines). By using the service, you grant us a limited license to process this data to generate your reports. The generated reports (PDFs, JSON exports) are yours to use for commercial purposes (pitching, marketing, sales).</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">5. Acceptable Use</h2>
              <p>You agree not to reverse engineer the AI models, use the service to generate illegal or hateful content, or attempt to bypass credit limits.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">6. Limitation of Liability</h2>
              <p>To the maximum extent permitted by law, BLACKLIGHT Films/BLACKBOXis shall not be liable for any indirect, incidental, or consequential damages arising from your use of the service or reliance on its data.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">7. Contact</h2>
              <p>For legal inquiries:</p>
              <div className="mt-4 p-6 bg-zinc-900 rounded-xl border border-zinc-800">
                 <p><strong>Email:</strong> <a href="mailto:support@blackbox-is.com" className="text-purple-400 hover:underline">support@blackbox-is.com</a></p>
              </div>
            </section>
          </div>

          <div className="mt-12 text-center pb-12">
            <button
              onClick={() => navigate('/')}
              className="inline-flex items-center text-zinc-400 hover:text-white transition-colors"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Return to Home
            </button>
          </div>
        </div>
      </main>
    </div>
  );
};

export default TermsPage;